import React, { Component } from 'react';
import TabHeader from './tab-header';

class Tab extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        const { onClick, tabActive } = this.props;

        return (
            <div className="tabs">
                <TabHeader tabs={this.props.children} handleClick={onClick} positionTab={tabActive}/>
                {this.props.children}
            </div>
        );
    }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/components/shared/tabs/index.js